<template>
  <AppContainer :is-loading>
    <div>
      <EPageTitleMobile :title="t(useTranslationPath(callerPath, 'title'))" />

      <EForm>
        <EFormField
          id="user"
          :label="t(useTranslationPath(callerPath, 'label'))"
          :hint="t(useTranslationPath(callerPath, 'hint'))"
        >
          <ERadioGroup v-model="v$.verificationOption.$model">
            <ERadio
              id="yes"
              name="yes"
              :label="t(useTranslationPath(callerPath, 'yes'))"
              :value="true"
              :hint="t(useTranslationPath(callerPath, 'yesHint'))"
            />
            <ERadio
              id="no"
              name="no"
              :label="t(useTranslationPath(callerPath, 'no'))"
              :value="false"
              :hint="t(useTranslationPath(callerPath, 'noHint'))"
            />
          </ERadioGroup>
        </EFormField>
      </EForm>
    </div>

    <template #bottom>
      <EButton
        :label="t(useTranslationPath(callerPath, 'next'))"
        block
        :disabled="v$.$invalid"
        @click="onSubmit"
      />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useGetConfigVar } from '@/composables/useGetConfigVar.js'
import { useGoBack } from '@/composables/useGoBack'
import { useLoginRedirect } from '@/composables/useLoginRedirect.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { EButton, EForm, EFormField, EPageTitleMobile, ERadio, ERadioGroup } from '@expansivefm/eds'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { inject, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const router = useRouter()
const { setCustomGoBack, resetGoBack } = useGoBack()

const appStore = useAppStore()
const axios = inject('$axios')
const { redirectToLogin } = useLoginRedirect(axios)
const callerPath = 'views.unauthenticated.verification.optional'

const isLoading = ref(null)

const form = reactive({
  verificationOption: null,
})

const validationRules = {
  verificationOption: { required },
}

const v$ = useVuelidate(validationRules, form)

onMounted(async () => {
  appStore.showBackButton = false
  isLoading.value = true

  const featureFlag = useGetConfigVar('ENGINEER_APP_FORCE_VERIFICATION_METHOD_ON_SIGN_IN')

  if (featureFlag) {
    await router.push({
      name: 'auth.verification.methods',
    })

    return
  }

  setCustomGoBack(() =>
    router.push({
      name: 'auth.user',
    }),
  )

  isLoading.value = false
  appStore.showBackButton = true
})

onUnmounted(async () => {
  resetGoBack()
})

const onSubmit = async () => {
  v$.value.$touch()

  if (v$.value.$invalid) {
    return
  }

  isLoading.value = true

  if (!form.verificationOption) {
    await redirectToLogin()
    return
  }

  await router.push({
    name: 'auth.verification.methods',
  })
}
</script>
